import React from 'react';
import { Link } from 'react-router-dom';
import { onChange, getCookie } from '../../utils';
import CONSTANT from '../../constant';
import Header from '../../component/common/Header';

import { getDateParts } from '../../utils';
import { getLeaveSummary } from '../../actions/LeaveAction';
import { getList } from '../../actions/EncashmentAction';
import Shimmer from '../../component/common/Shimmer';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            self: undefined,
            assigned: undefined,
            date: new Date(),

            // leaveType: { name: 'leaveType', value: 'all', error: '', isRequired: true },
            // leaveSummary: undefined
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allLeaves;

        this.loadList();
        // this.loadLeaveSummary();

    }

    render() {
        const { assigned, self, leaveSummary, date } = this.state;
        const ud = getCookie(CONSTANT.cookie.userDetail);
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        {/* <div className="row my-3">
                            <div className="col-md-12">
                                <h1 className="page-title">Leaves Balance</h1>
                            </div>
                        </div> */}
                        {/* <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            {
                                                leaveSummary !== undefined && leaveSummary.filter((item: any) => item.code !== CONSTANT.static.leaveType.cml).map((item: any, index: any) => {
                                                    const balance = item.total - item.used - item.pending;
                                                    const isNumber = balance % 1 === 0;
                                                    return (
                                                        <div className="col" key={index}>
                                                            <strong style={{ fontSize: '2rem' }}>
                                                                {isNumber ? balance : balance.toFixed(2)}
                                                            </strong><br />
                                                            {item.name}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        {
                                            leaveSummary === undefined && <Shimmer />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div> */}


                        <div className="row mt-3">
                            <div className="col-md-10">
                                <h1 className="page-title">My Request in {date.getFullYear()}</h1>
                            </div>
                            {/* <div className="col-md-2">
                                <Link to={CONSTANT.component.userLeaveEncashmentList.url} className="btn btn-sm submit-button btn-block">
                                    Leave Encashment
                                </Link>
                            </div> */}
                            <div className="col-md-2">
                                <Link to={CONSTANT.component.userLeaveEncashmentApply.url} className="btn btn-sm submit-button btn-block">
                                    <i className="fa fa-plus-circle mr-2" />
                                    Request Encashment
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Assigned To</th>
                                                <th scope="col">Requested by</th>
                                                <th scope="col"># Days</th>
                                                <th scope="col">Modified</th>
                                                <th scope="col">Status</th>
                                            </tr>
                                            {
                                                self === undefined && <tr>
                                                    <td colSpan={9} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                self !== undefined && self.length === 0 && <tr>
                                                    <td colSpan={9} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                self !== undefined && self.map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.userLeaveEncashmentDetail.url.replace(':code', item.id);
                                                    const dated = getDateParts(item.modifiedOn);
                                                    return (
                                                        <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.assignedToName}</td>
                                                            <td>{item.createdByName}</td>
                                                            <td>{item.numberOfDays}</td>
                                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                            <td>
                                                                {
                                                                    item.statusId === null ? <span>Pending</span> : <span>{item.statusName}</span>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                        <div className="row mt-3">
                            <div className="col-md-12">
                                <h1 className="page-title">Request Pending With Me</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Assigned To</th>
                                                <th scope="col">Requested by</th>
                                                <th scope="col"># Days</th>
                                                <th scope="col">Modified</th>
                                                <th scope="col">Status</th>
                                            </tr>
                                            {
                                                assigned === undefined && <tr>
                                                    <td colSpan={9} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                assigned !== undefined && assigned.length === 0 && <tr>
                                                    <td colSpan={9} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                assigned !== undefined && assigned.map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.userLeaveEncashmentDetail.url.replace(':code', item.id);
                                                    const dated = getDateParts(item.modifiedOn);
                                                    return (
                                                        <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.assignedToName}</td>
                                                            <td>{item.createdByName}</td>
                                                            <td>{item.numberOfDays}</td>
                                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                            <td>
                                                                {
                                                                    item.statusId === null ? <span>Pending</span> : <span>{item.statusName}</span>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-2">
                                <button type="button" onClick={this.previousYear} className="btn btn-link btn-sm next-control btn-block">
                                    <i className="fa fa-angle-double-left mr-1 pe-none" aria-hidden="true"></i>
                                    Year {date.getFullYear() - 1}
                                </button>
                            </div>
                            <div className="col-md-8"></div>
                            <div className="col-md-2">
                                <button type="button" onClick={this.nextYear} className="btn btn-link btn-sm float-right next-control btn-block">
                                    Year {date.getFullYear() + 1}
                                    <i className="fa fa-angle-double-right ml-1 pe-none" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    previousYear = () => {
        this.setState({ date: new Date(this.state.date.setFullYear(this.state.date.getFullYear() - 1)) }, () => {
            this.loadList();
            this.loadLeaveSummary();
        });

    }
    nextYear = () => {
        this.setState({ date: new Date(this.state.date.setFullYear(this.state.date.getFullYear() + 1)) }, () => {
            this.loadList();
            this.loadLeaveSummary()
        });
    }

    loadLeaveSummary = () => {
        const { date } = this.state;
        getLeaveSummary(date.getFullYear()).then((res: any) => {
            if (res) {
                this.setState({
                    leaveSummary: res.result.leaveTypeList
                })
            }
        });
    }

    loadList = () => {
        const { date } = this.state;
        getList(date.getFullYear()).then((res: any) => {
            this.setState({ assigned: res.result.assigned, self: res.result.self });
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }
}

export default ComponentName;